module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/views/setting/taxes/taxes-show/taxes-show.component.scss
// module id = ./src/app/views/setting/taxes/taxes-show/taxes-show.component.scss
// module chunks = main